// Mood Board Color
export const BG_PRIMARY = '#934b60';
export const BG_SECONDARY = '#fff8ed';

// Text Color
export const TEXT_PRIMARY = '#000000'; //brown dark
export const TEXT_SECONDARY = '#934b60'; // Title color section
export const TEXT_ALTERNATIVE = '#e0af34'; // Button Text Color

export const BUTTON_MAIN_COLOR = '#5f726d';
export const BUTTON_MAIN_GRADIENT = '#a5b0a8';

// Music & Navigation Color
export const NAVIGATION_COLOR = '#e5cc9e';
export const ICON_NAVIGATION_COLOR = '#ffffff'; // Warna Iconnya

export const BUTTON_GRADIENT = `linear-gradient(to left, var(--chakra-colors-btnMainColor), var(--chakra-colors-btnMainGradient) 140%)`;
// Default Button Color
export const BUTTON_PROPS = {
  _active: { opacity: '.8' },
  _hover: { opacity: '.8' },
  _focus: { opacity: '.8' },
};
